const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/allowedECheckinAppointmentTypes.ts';
import { IActionHandlersMap, KisApiAction, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { addRequestActionHandlers, getData, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { PatAppStoreState } from './setup/rootReducer';
import {
    loadAllowedEchekinAppointmentTypes,
    REQUEST_ACTION_TYPES_ALLOWED_ECHECKIN_APPOINTMENT_TYPES,
} from 'App/actions/allowedAppointmentTypes';
import { AppointmentType, CaseType } from '@cistec/common_web/defs/kisim';
import { createSelector } from 'reselect';

interface EcheckinSettings {
    appointmentTypes: AppointmentType[];
    caseTypes: CaseType[];
}

const handlers: IActionHandlersMap = {};

const eCheckinAppointmentSettingsDataProcessorFunction = (
    action: KisApiAction,
    state?: ReducerState
): EcheckinSettings => {
    return {
        appointmentTypes: ((action.payload.CONTENT.Termintypen as string).split(',') as AppointmentType[]) || [],
        caseTypes: ((action.payload.CONTENT.Fallarten as string).split(',') as CaseType[]) || [],
    };
};

addRequestActionHandlers(
    handlers,
    REQUEST_ACTION_TYPES_ALLOWED_ECHECKIN_APPOINTMENT_TYPES,
    undefined,
    eCheckinAppointmentSettingsDataProcessorFunction
);

export const allowedEcheckinAppointmentSettingsReducer = makeReducer(handlers);

// SELECTORS

const selectAllowedEcheckinAppointmentSettingsState = (state: PatAppStoreState) =>
    state.allowedEcheckinAppointmentSettings;

export const selectAllowedEcheckinAppointmentSettings = createSelector(
    [selectAllowedEcheckinAppointmentSettingsState],
    settings => getData(settings) || { appointmentTypes: [], caseTypes: [] }
);

// HOOKS

export function useAllowedEcheckinAppointmentSettings() {
    return useRemoteData2('allowedEcheckinAppointmentSettings', {
        request: dispatch => dispatch(loadAllowedEchekinAppointmentTypes()),
        select: selectAllowedEcheckinAppointmentSettings,
    });
}
